import { render, staticRenderFns } from "./ManageDocument.vue?vue&type=template&id=00861fc6&scoped=true&lang=pug&"
import script from "./ManageDocument.vue?vue&type=script&lang=js&"
export * from "./ManageDocument.vue?vue&type=script&lang=js&"
import style0 from "./ManageDocument.vue?vue&type=style&index=0&id=00861fc6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00861fc6",
  null
  
)

export default component.exports